import { ENV } from '@/pages/home/_config/config';

/** 前端路由 path，与 routers.ts 中 ./ipCollaboration 一致；管理端菜单 path 需对齐 */
export const IP_COLLABORATION_ROUTE_PATH = 'ipCollaboration';

/** 同域嵌入页地址（预发布/正式随当前站点 origin） */
export const IP_COLLABORATION_EMBED_URL = '/ds/ip/';

const IP_COLLABORATION_ENABLED_ENVS = ['pre', 'pro'] as const;

export const isIpCollaborationEnabled = (): boolean =>
  IP_COLLABORATION_ENABLED_ENVS.includes(
    ENV as (typeof IP_COLLABORATION_ENABLED_ENVS)[number],
  );
